<template src="../templates/favourite-icon.html" />

<script setup>

import { onMounted, ref } from 'vue';
import { useStorage } from "../composables/useStorage";

const props = defineProps({
    type: {
        type: String,
        required: true,
    },
    id: {
        type: Number,
        required: true,
    },
    cssClasses: {
        type: Object,
        default: () => ({}),
    },
    isRemoveBtn: {
        type: Boolean,
        default: false,
    }
})

const favId = ref('');
const isFavourite = ref(false);

onMounted( () => {
    favId.value = `${props.type}-${props.id}`
    isFavourite.value = isAdded();
});

const toggleFavourite = () => {
    isFavourite.value = !isFavourite.value;

    const favourites = useStorage('favourites');
    const index = favourites.indexOf(favId.value);
    if (index > -1) {
        if (props.isRemoveBtn) {
            const event = new CustomEvent('favourite-remove', { detail: { favId: favId.value } });
            window.dispatchEvent(event);
        } else {
            favourites.splice(index, 1);
        }
    } else {
        favourites.unshift(favId.value);
    }
    useStorage('favourites', favourites);

    // Emit a storage event to notify other components about the change
    window.dispatchEvent(new Event('storage'));
}

const isAdded = () => {
    const favourites = useStorage('favourites');
    return favourites.includes(favId.value)
}

</script>
